import React from 'react';
import { useAppSelector } from '../core/hooks';
import { messagesSelector } from '../features/i18nMessages';
import BaseMessageProvider from './BaseMessageProvider';

interface I18nInput {
  children: React.ReactNode;
}

const I18nProvider = ({ children }: I18nInput) => {
  const messages = useAppSelector(messagesSelector);
  return <BaseMessageProvider messages={messages}>{children}</BaseMessageProvider>;
};

export default I18nProvider;
